module.exports = __webpack_public_path__ + "img/Language Icon.0cd46af3.svg";